import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useContext } from "react";
import { Button } from "react-bootstrap";
import { AuthContext } from "@beeldit/user-and-access/auth/AuthContext";
import checkPermissions from "@beeldit/user-and-access/auth/services/checkPermissions";
import checkRoles from "@beeldit/user-and-access/auth/services/checkRoles";
import { t } from "i18next";
import { BulkActionActionContext } from "../context/BulkActionContext";

interface ContextType {
  elementsIds: string[];
}

function BeelditTableHeaderActions(props: any) {
  const { actions, bulkActions } = props;
  const { user } = useContext(AuthContext);
  const { elementIds } = useContext(BulkActionActionContext);


  const checkElementsIds = () => {
    if (elementIds) {
      return elementIds.length > 0;
    }
    return false;
  };

  return (
    <>
      {actions.map((action: any) => {
        if (
          checkPermissions(user, action.permissions) &&
          checkRoles(user, action.roles) &&
          action.show
        ) {
          return (
            <Button
              className="icon-button"
              key={action.name}
              onClick={() => action.action()}
              aria-label={action.showLabel ? t(action.label) : ""}
            >
              {action.icon}
              {action.showLabel ? (
                <span className="action-button-text">{t(action.label)}</span>
              ) : null}
            </Button>
          );
        }
        return null;
      })}
      {bulkActions && bulkActions.map((bulkAction: any) => {        
        if (
          checkPermissions(user, bulkAction.permissions) &&
          checkRoles(user, bulkAction.roles) &&
          checkElementsIds() &&
          bulkAction.show
        ) {
          return (
            <Button
              className="icon-button"
              key={bulkAction.name}
              onClick={() => bulkAction.action()}
              aria-label={bulkAction.showLabel ? t(bulkAction.label) : ""}
            >
              {bulkAction.icon}
              {bulkAction.showLabel ? (
                <span className="action-button-text">{t(bulkAction.label)}</span>
              ) : null}
            </Button>
          );
        }
        return null;
      })}
    </>
  );
}

export default BeelditTableHeaderActions;
